import { Component, Inject } from '@angular/core';
import { MODAL_CONTROLLER, ModalController } from 'shared';
import { UserTrackingHelperService } from '../../../services/user-tracking-helper.service';
import { ModalComponent } from '../../../../../../shared/src/lib/components/modal/modal.component';
import { FormsModule } from '@angular/forms';
import { ModalContentComponent } from '../../../../../../shared/src/lib/components/modal-content/modal-content.component';
import { TextareaComponent } from '../../../../../../shared/src/lib/components/textarea/textarea.component';
import { ModalButtonsComponent } from '../../../../../../shared/src/lib/components/modal-buttons/modal-buttons.component';
import { ModalButtonComponent } from '../../../../../../shared/src/lib/components/modal-button/modal-button.component';
import { Angulartics2OnModule } from 'angulartics2';
import { TranslateModule } from '@ngx-translate/core';

export interface OverrideModalResult {
  comment: string;
}

// DEPRECATED: This component does not seem to be used anywhere.

@Component({
    selector: 'app-alarm-override-modal',
    templateUrl: './alarm-override-modal.component.html',
    styleUrls: ['./alarm-override-modal.component.scss'],
    imports: [ModalComponent, FormsModule, ModalContentComponent, TextareaComponent, ModalButtonsComponent, ModalButtonComponent, Angulartics2OnModule, TranslateModule]
})
export class AlarmOverrideModalComponent {

  public comment: string;

  public onSubmit() {
    this.controller.complete({comment: this.comment});
  }

  constructor(
    @Inject(MODAL_CONTROLLER)  private controller: ModalController<OverrideModalResult>,
    private userTrackingHelperService: UserTrackingHelperService
  ) { }

  dismiss() {
    this.userTrackingHelperService.trackUserAction('acknowledgeClicked', 'exitClicked');
  }

}
